import { render, staticRenderFns } from "./content-page.vue?vue&type=template&id=256a46d6"
import script from "./content-page.vue?vue&type=script&lang=js"
export * from "./content-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports